import React from 'react';
import { Wrench } from '@phosphor-icons/react';

/**
 * Placeholder shown in place of a page an admin has closed.
 *
 * Rendered by <ModuleGate> (src/moduleAccess.jsx). To open or close a page, or
 * to change the copy shown here, use Admin → Module Access — no redeploy.
 */
const ComingSoon = ({ title, description, accent = '#10b981', icon: Icon = Wrench }) => (
  <div className="p-8 flex items-center justify-center min-h-[60vh]" data-testid="coming-soon">
    <div className="max-w-md w-full text-center border border-dashed border-border rounded-xl bg-surface px-8 py-12">
      <div className="w-14 h-14 rounded-xl mx-auto mb-5 flex items-center justify-center relative overflow-hidden">
        <span className="absolute inset-0 opacity-10" style={{ backgroundColor: accent }} aria-hidden="true" />
        <Icon size={26} weight="bold" style={{ color: accent }} className="relative" />
      </div>

      <div className="inline-block relative overflow-hidden text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded mb-3">
        <span className="absolute inset-0 opacity-10" style={{ backgroundColor: accent }} aria-hidden="true" />
        <span className="relative" style={{ color: accent }}>Coming soon</span>
      </div>

      <h1 className="text-2xl font-heading font-bold text-text-primary mb-2" data-testid="coming-soon-title">
        {title}
      </h1>

      <p className="text-[13px] text-text-secondary leading-relaxed">
        {description || `${title} is still being built. We'll switch it on for you the moment it's ready.`}
      </p>
    </div>
  </div>
);

export default ComingSoon;
